import styled from "styled-components";

export const MainContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TextAboutTools = styled.div`
    font-size: 22px;
    color: rgba(255, 255, 255, 0.75);
    padding: 0.5rem;
    @media ${(props) => 'screen and (max-width: 400px)'} {
        font-size: 18px;
      }
`;

export const ReactLogoContainer = styled.div`
    width: 25px;
    height: 25px;
    animation: rotate 3s infinite linear;
    transform-origin: center center;
    @keyframes rotate {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export const ReactLogo = styled.div`
    width: 100%;
    height: 100%;
    background-image: url("https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg");
    background-size: cover;
    background-position: center;
`;